import { IState } from './state';
import { MutationTree } from 'vuex';

export default {
    setDataPolicy (state: IState, { value, checksum: __datapolicy_checksum, type: __datapolicy_type }) {
        state.__datapolicy_checksum = __datapolicy_checksum;
        state.__datapolicy_type = __datapolicy_type;
        state.dataPolicyAccepted = state.dataPolicyAccepted.replaceValue(value);
    },
    setDataPolicyError (state: IState, value: boolean) {
        state.dataPolicyError = value
    },
    setOrganizerAgreement (state: IState, { value }) {
        state.organizerAgreementAccepted = state.organizerAgreementAccepted.replaceValue(value);
    },
    setOrganizerAgreementError (state: IState, value: boolean) {
        state.organizerAgreementError = value
    },
    setFormSubmitted (state: IState, isSubmitted: boolean): void {
        state.formSubmitted = isSubmitted;
    }
} as MutationTree<IState>
